// extracted by mini-css-extract-plugin
export var actionButton = "_ac-1";
export var actionButtons = "_ac-2";
export var actions = "_ac-0";
export var aiUnread = "_ac-10";
export var alignCenter = "_ac-h";
export var backWrapper = "_ac-3";
export var cellContainer = "_ac-4";
export var checkboxContainer = "_ac-5";
export var contentContainer = "_ac-6";
export var contentHeader = "_ac-8";
export var conversationsTableWrapper = "_ac-s";
export var draftReplyBadgeContainer = "_ac-m";
export var dropdownItem = "_ac-b";
export var dropdownItemsContainer = "_ac-a";
export var dropdownTitle = "_ac-c";
export var errorIcon = "_ac-7";
export var filter = "_ac-d";
export var gray = "_ac-i";
export var headerActionButtons = "_ac-e";
export var headerCheckboxContainer = "_ac-f";
export var icon = "_ac-j";
export var menuContainer = "_ac-k";
export var noMoreTicketsIcon = "_ac-12";
export var noMoreTicketsSubText = "_ac-13";
export var oneLine = "_ac-l";
export var optionsButton = "_ac-n";
export var plus = "_ac-o";
export var portalButtonsWrapper = "_ac-g";
export var red = "_ac-p";
export var scrolledTop = "_ac-9";
export var search = "_ac-q";
export var selectedConversationsCount = "_ac-r";
export var spinner = "_ac-t";
export var strong = "_ac-u";
export var summaryCell = "_ac-v";
export var tableContainer = "_ac-11";
export var tagContainer = "_ac-w";
export var threeDots = "_ac-x";
export var twoLines = "_ac-y";
export var unread = "_ac-z";